import { render } from "./Unsupported.vue?vue&type=template&id=42d91750"
const script = {}

import exportComponent from "/home/runner/work/space-app/space-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__